import React from 'react';
import CustomSelect, { monthOptions, yearOptions } from './CustomSelect';

interface Props {
  month: number;                     // 1–12
  year: number;
  onMonthChange: (m: number) => void;
  onYearChange: (y: number) => void;
  yearEnd?: number;
}

const DateNav: React.FC<Props> = ({ month, year, onMonthChange, onYearChange, yearEnd }) => {
  const now = new Date().getFullYear();
  return (
    <div className="flex items-center gap-2">
      <CustomSelect value={month} options={monthOptions()} onChange={onMonthChange} />
      <CustomSelect value={year} options={yearOptions(1900, yearEnd ?? now + 1)} onChange={onYearChange} />
    </div>
  );
};

export default DateNav;
